import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';

import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import WpButton from 'Wpds/components/button/WpButton';

import { useToggle } from 'Shared/utils/hooks';
import { advanceOnboardingStateAction } from 'Shared/actions/onboardingState';

import { OnboardingWizardStep } from '../../../../types';

type Props = {
  formRef: {
    current: HTMLFormElement;
  };
  isSignUpTab: boolean;
  errorsDisableSubmit?: Function;
};

function ButtonsArea({ formRef, isSignUpTab, errorsDisableSubmit }: Props) {
  const dispatch = useDispatch();
  const step: OnboardingWizardStep = useSelector(state => state.onboardingState.step);
  const showFinishButton = useSelector(state => state.onboardingState.showFinishButton);
  const [isSubmitLoading, toggleIsSubmitLoading] = useToggle(false);

  const showSkipButton = [
    OnboardingWizardStep.groupWorkspacesFromCalendar,
    OnboardingWizardStep.inviteTeammates,
    OnboardingWizardStep.discussionTopics,
  ].includes(step);
  const handleSkipClick = useCallback(() => dispatch(advanceOnboardingStateAction({ didSkip: true })), [dispatch]);

  const { submitting, errors } = useFormState();
  const errorsExist = errorsDisableSubmit
    ? errorsDisableSubmit(errors)
    : !!Object.keys(errors).filter(key => errors[key]).length;

  const labelButton = () => {
    if (isSignUpTab) return 'Create Account';
    if (showFinishButton) return 'Finish';
    return 'Next';
  };

  const handleSubmitClick = () => {
    if (isSignUpTab) {
      toggleIsSubmitLoading();
      if (formRef.current) formRef.current.submit();
    }
  };

  return (
    <div className={`${isSignUpTab ? 'pt-1' : 'd-flex justify-content-end mt-4 pt-3'}`}>
      <WpButtonGroup>
        {showSkipButton ? (
          <WpButton disabled={submitting} variant="tertiary" onClick={handleSkipClick}>
            Skip
          </WpButton>
        ) : null}

        <WpButton
          btnType="submit"
          disabled={errorsExist}
          loading={submitting || isSubmitLoading}
          onClick={handleSubmitClick}
          size={isSignUpTab ? 'lg' : 'md'}
          block={isSignUpTab}
        >
          {labelButton()}
        </WpButton>
      </WpButtonGroup>
    </div>
  );
}

export default ButtonsArea;
